import { NoteCreate } from 'app/agriculture/routes/Notes/NoteCreate/NoteCreate';
import { NoteDelete } from 'app/agriculture/routes/Notes/NoteDelete/NoteDelete';
import { NoteDetails } from 'app/agriculture/routes/Notes/NoteDetails/NoteDetails';
import { NoteDetailsSkeleton } from 'app/agriculture/routes/Notes/NoteDetails/NoteDetailsSkeleton';
import { NoteEdit } from 'app/agriculture/routes/Notes/NoteEdit/NoteEdit';
import { NoteList } from 'app/agriculture/routes/Notes/NoteList/NoteList';
import { NoteListSkeleton } from 'app/agriculture/routes/Notes/NoteList/NoteListSkeleton';
import { RouteConfig } from 'app/agriculture/router/types';

export const notesRouteConfig: RouteConfig = {
    rootPath: 'notes',
    routeElements: {
        Create: { Component: NoteCreate },
        Delete: { Component: NoteDelete },
        Details: { Component: NoteDetails, Skeleton: NoteDetailsSkeleton },
        Edit: { Component: NoteEdit },
        List: { Component: NoteList, Skeleton: NoteListSkeleton },
    },
};
